import { render, staticRenderFns } from "./AddContragent.vue?vue&type=template&id=087f2806&"
import script from "./AddContragent.vue?vue&type=script&lang=js&"
export * from "./AddContragent.vue?vue&type=script&lang=js&"
import style0 from "./AddContragent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports